/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "./actionTypes";
import { axiosSA } from "../../axios";
import {
  sortUsers,
  sortContractors,
  setColorCode,
} from "./../../shared/geofence";
import { toast } from "react-toastify";
import { constant } from "./../../shared/constants/constants";
import { setToken } from "./index";
import {
  convertContractorsV1toV0,
  convertRequestBodyOfWorkorderV0toV1,
  convertWorkordersUserV1toV0,
} from "../../shared/helper";

// fetch work order users
export const fetchUsers = () => {
  return async (dispatch, getState) => {
    let token = await dispatch(setToken());

    axiosSA
      .get("/employees/list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          pageSize: 100,
          pageNo: 1,
        },
      })
      .then((res) => {
        // set user color code
        setColorCode(
          convertWorkordersUserV1toV0(res.data.data),
          getState().user.contractors
        );
        dispatch(setUser(sortUsers(convertWorkordersUserV1toV0(res.data.data))));
      })
      .catch((err) => {
              });
  };
};

// fetchContractors
export const fetchContractors = () => {
  return async (dispatch, getState) => {
    let token = await dispatch(setToken());
    axiosSA
      .get("/partners/list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          pageSize: 100,
          pageNo: 1,
        },
      })
      .then((res) => {
        // set contractors color code
        setColorCode(
          getState().user.users,
          convertContractorsV1toV0(res.data.data)
        );
        dispatch(
          setContractor(
            sortContractors(convertContractorsV1toV0(res.data.data))
          )
        );
      })
      .catch((err) => {
              });
  };
};

// save assigned assigned workorder user
export const saveWorkOrderUser = (workOrderId, contactId) => {
  return async (dispatch, getState) => {
    let token = await dispatch(setToken());

    let postData = {
      user_1: contactId ? contactId : null,
    };

    postData = convertRequestBodyOfWorkorderV0toV1(postData);

    axiosSA
      .post(`/workorders/${workOrderId}`, postData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        toast.success(constant.TECHNICIAN_ASSIGNED);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorCode === 845
        ) {
          toast.error(constant.INSUFFICIENT_ACCESS);
        } else toast.error(constant.ERROR_IN_ASSIGNING_TECHNICIAN);
      });
  };
};

// set users in redux store
export const setUser = (users) => {
  return {
    type: actionTypes.SET_USER,
    users,
  };
};

// set contractors in redux store
export const setContractor = (contractors) => {
  return {
    type: actionTypes.SET_CONTRACTOR,
    contractors,
  };
};
